import { useTranslate } from "@similarweb/i18n-provider";
import { Present } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { ImagePlaceholderContainer } from "./ImagePlaceholderContainer";

export const VideoThumbnailPlaceholder = () => {
    const { translate } = useTranslate();

    return (
        <ImagePlaceholderContainer>
            <Stack
                alignItems="center"
                gap="8px"
            >
                <Text
                    fontVariant="report"
                    color={colorsPalettes.carbon[300]}
                >
                    {translate("activation.alerts.cards.video-thumbnail.error")}
                </Text>
                <Present
                    size="lg"
                    color={colorsPalettes.carbon[200]}
                />
            </Stack>
        </ImagePlaceholderContainer>
    );
};
